export default __webpack_public_path__ + "static/radio-83ee9cae7761b725950f6140508744b2.png";